module.exports = __webpack_public_path__ + "img/3.bbe4a68b.jpg";